import React from "react";

import { NavLink, Route } from "react-router-dom";

import PendingOrders from "./PendingOrders";
import ConfirmedOrders from "./ConfirmedOrders";
import DeliveredOrders from "./DeliveredOrders";
import CancelledOrders from "./CancelledOrders";

import styled from "styled-components";

const Container = styled.div`
  width: 90%;
  height: 90%;
  background: #f5f5f5;
  padding: 3.5% 5%;
  border-radius: 5px;
`;
const OrdersHeader = styled.div`
  width: 100%;
  height: 5%;
  @media (max-width: 768px) {
    height: 2%;
  }
`;
const HeaderLeft = styled.div`
  width: 25%;
  height: 100%;
  float: left;
`;
const Title = styled.h2`
  font-size: 1.2em;
  margin: 0;
  padding: 0;
  font-weight: 500;
`;
const Amount = styled.p`
  font-size: 1em;
  margin: 0;
  padding: 5px 0;
`;
const OrdersNav = styled.div`
  width: 100%;
  height: 42px;
  margin-top: 20px;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
`;
const NavItem = styled(NavLink)`
  display: block;
  width: 22%;
  background: white;
  padding: 12px 0 7px 0;
  font-weight: 500;
  color: white;
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  color: black;
`;
const OrdersContainer = styled.div`
  width: 103%;
  height: 78%;
  margin-top: 20px;
  overflow-y: scroll;
`;
function Orders() {
  return (
    <Container>
      <OrdersHeader>
        <HeaderLeft>
          <Title>Orders</Title>
          {/* <Amount>30 orders completed</Amount> */}
        </HeaderLeft>
      </OrdersHeader>
      <OrdersNav>
        <NavItem
          to="/user-profile/orders"
          exact
          activeStyle={{ background: "#276FB7", color: "white" }}
        >
          Pending Orders
        </NavItem>
        <NavItem
          to="/user-profile/orders/confirmed"
          activeStyle={{ background: "#276FB7", color: "white" }}
        >
          Confirmed Orders
        </NavItem>
        <NavItem
          to="/user-profile/orders/delivered"
          activeStyle={{ background: "#276FB7", color: "white" }}
        >
          Delivered Orders
        </NavItem>
        <NavItem
          to="/user-profile/orders/cancelled"
          activeStyle={{ background: "#276FB7", color: "white" }}
        >
          Cancelled Orders
        </NavItem>
      </OrdersNav>
      <OrdersContainer>
        <Route exact path="/user-profile/orders" component={PendingOrders} />
        <Route
          exact
          path="/user-profile/orders/confirmed"
          component={ConfirmedOrders}
        />
        <Route
          exact
          path="/user-profile/orders/delivered"
          component={DeliveredOrders}
        />
        <Route
          exact
          path="/user-profile/orders/cancelled"
          component={CancelledOrders}
        />
      </OrdersContainer>
    </Container>
  );
}

export default Orders;
